import React, { useEffect, useMemo, useState } from 'react';
import { Footer, HeaderNavi, ScrollTop, } from '@components';
import { useNavigate, useSearchParams, useParams,   } from 'react-router-dom';
import { AuthHook, useLectureDetail } from '@hooks';
import { getOptions  } from '@utils/CommonCodes';
import {ModalUser} from './ModalUser';
import {ApplyCompleteModal} from './ApplyCompleteModal';
import { NoticeAgreeModal } from './NoticeAgreeModal';

const LectureDetail = () => {
    const { auth } = AuthHook();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { lectureId } = useParams();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDoneModal, setIsDoneModal] = useState(false);
    const [isNoticeOpen, setIsNoticeOpen] = useState(false);
    const managedAlertedSet = new Set(); 

    const urlEduType = searchParams.get('eduType') || 'B';
    const { lecture, schedule, applyStatus, isPending, isApproved, isReapply, isManaged, loading, handleCancelApply, refetchStatus } = useLectureDetail(lectureId);

    const limit = Number(lecture?.eduStdntLimit ?? 0);          // 정원(없거나 0이면 무제한/미설정으로 처리)
    const current = Number(lecture?.curStudentCnt ?? 0);        // 현재 인원
    const isFull = limit > 0 && current >= limit; 

    // 사용자/강의 기준으로 고유 키 생성 (세션 동안 1회만 알림)
    const warnedKey = useMemo(
        () => `managedWarned:${auth?.memberId || 'guest'}:${lectureId}`,
        [auth?.memberId, lectureId]
    );

    const grouped = useMemo(() => {
        if (!Array.isArray(schedule) || schedule.length === 0) return {};
        return schedule.reduce((acc, row) => {
            (acc[row.eduDt] = acc[row.eduDt] || []).push(row);
            return acc;
        }, {});
    }, [schedule]);  

    useEffect(() => {
        if (!auth.isAuthenticated || !isManaged) return;
        if (managedAlertedSet.has(warnedKey)) return;   // 이미 알림 처리됨 → 스킵
        managedAlertedSet.add(warnedKey);               // 최초 진입에만 기록
        alert("이 강의는 관리자에 의해서 수강신청된 강의입니다. \n수강신청정보를 확인하고 싶으시면 마이페이지를 확인해주세요!");
    }, [auth.isAuthenticated, isManaged, warnedKey]);

    if (loading) return <div>로딩중</div>;
    if (!lecture) return null;

    const lectureNm = 
    lecture.catgRegYear && lecture.eduNo && lecture.lectureNm
      ? `[${lecture.catgRegYear}년 ${lecture.eduNo}차] ${lecture.lectureNm}` : "-";
    const period =
        lecture.applyStartDt && lecture.applyEndDt
        ? `${lecture.applyStartDt} ~ ${lecture.applyEndDt}`
        : "-";
    const lectureDate =
        lecture.firstDt && lecture.lastDt
        ? `${lecture.firstDt} ~ ${lecture.lastDt}`
        : lecture.firstDt || "-";
    const hoursText = lecture.eduHours ? `${lecture.eduHours} 시간` : "-";
    const feeText = lecture.eduPee ? `₩ ${lecture.eduPee.toLocaleString()} ` : "-";
    const addressText = lecture.address1
        ? `${lecture.zipcode ? `(${lecture.zipcode}) ` : ""}${lecture.address1}${
            lecture.address2 ? ` ${lecture.address2}` : ""
        }`
        : "-";

    const handleMenuClick = (code) => {
        navigate(`/lecture?eduType=${code}`); 
      };
    
    const handleList = () => {
        navigate(`/lecture?eduType=${urlEduType}`); 
    }

    const openModal = () => {
        if (isFull) {
            alert('정원이 마감되어 신청할 수 없습니다.');
            return;
        }
        if (!auth.isAuthenticated) {
            alert('로그인이 필요합니다.');
            return;
        }
        setIsNoticeOpen(true);
    };

    const openUserModalAfterNotice = () => {
    setIsModalOpen(true);
  };

    const handleApplyDone = () => {
        refetchStatus();
        setIsModalOpen(false);
        setIsDoneModal(true);
    }



    const renderSchedule = (date, list) => {
        // 현재 idx부터 같은 강사가 몇 행 이어지는지 계산
        const getSpan = (start) => {
          let span = 1;
          while (
            start + span < list.length &&
            list[start + span].instructorNm === list[start].instructorNm
          ) {
            span += 1;
          }
          return span;
        };
      
        return (
          <div key={date} style={{ marginTop: 16 }}>
            <span style={{fontSize:"1.3rem", fontWeight:"500"}}>
              {date}
            </span>
      
            <div className="lineTop_tb01"> 
                <table className="lineTop_tb">
                <thead>
                    <tr>
                    <th style={{ width: "8%" }}>교시</th>
                    <th>과목</th>
                    <th style={{ width: "22%" }}>시간</th>
                    <th style={{ width: "22%" }}>강사</th>
                    </tr>
                </thead>
                <tbody>
                    {list.map((c, idx) => {
                    const isFirst =
                        idx === 0 ||
                        list[idx - 1].instructorNm !== c.instructorNm;
                    const span = isFirst ? getSpan(idx) : 0; 
        
                    return (
                        <tr key={`${date}-${c.classNo}`}>
                        <td>{c.classNo}</td>
                        <td>{c.subject}</td>
                        <td>{`${c.startTm.slice(0, 2)}:${c.startTm.slice(2, 4)} ~ ${c.endTm.slice(0, 2)} : ${c.endTm.slice(2, 4)}`}</td>
                        {isFirst && <td rowSpan={span}>{c.instructorNm}</td>}
                        </tr>
                    );
                    })}
                </tbody>
                </table>
            </div>
          </div>
        );
    };



    return (
        <>
        <ScrollTop />
        <main id="main" className="mainpage">
            <div>
                <div className="section main-contact">
                    <HeaderNavi />
                    <div className="sub-container">
                        <div className="sub-layout">
                            <div className="left-menu">
                                <ul>
                                    {getOptions("EDU_TYPE")
                                        .filter(opt => ["B", "C", "D", "E"].includes(opt.comdCode))
                                        .map(({ comdCode, comdName }) => (
                                        <li
                                            key={comdCode}
                                            className={urlEduType === comdCode ? 'sub-menu-on' : ''}
                                            onClick={() => handleMenuClick(comdCode)}
                                        >
                                            {comdName}
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="sub-contact">
                                <div className="tit-T">{lectureNm}</div>
                                <div className="lineTop_tb01"> 
                                    <table className="lineTop_tb">
                                    <colgroup>
                                        <col style={{ width: "20%" }} />
                                        <col style={{ width: "9%" }} />
                                        <col style={{ width: "18%" }} />
                                        <col style={{ width: "18%" }} />
                                        <col style={{ width: "7%" }} />
                                        <col style={{ width: "9%" }} />
                                        <col style={{ width: "10%" }} />
                                        <col style={{ width: "9%" }} />
                                    </colgroup>
                                        <thead>
                                            <tr>
                                                <th>교육분류</th>
                                                <th>교육유형</th>
                                                <th>신청기간</th>
                                                <th>교육일자</th>
                                                <th>교육시간</th>
                                                <th>정원수</th>
                                                <th>수강료</th>
                                                <th>교육상태</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>{lecture.eduCategoryNm}</td>
                                                <td>{lecture.eduTypeNm}</td>
                                                <td>{period}</td>
                                                <td>{lectureDate}</td>
                                                <td>{hoursText}</td>
                                                <td>{lecture.curStudentCnt}/{lecture.eduStdntLimit ?? ""}</td>
                                                <td>{feeText}</td>
                                                <td>{lecture.lectureStatusNm}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                
                                <div className="view-txt">
                                    <span>관련법령</span>
                                    {lecture.eduLaw || '관련 법령 정보 없음'}
                                    <span>교육목표</span>
                                    {lecture.eduGoal}
                                    <span>교육내용</span>
                                    <div dangerouslySetInnerHTML={{ __html: lecture.eduContents }} />
                                    <span>수료조건</span>
                                    <p>출석(100%)</p>
                                    <b className="txt-red small-font">* 정해진 교육시간을 모두 이수했을 경우에만 수료 할 수 있습니다.</b>
                                    <span>교육장소</span>
                                    <p>{addressText}</p>


                                    <span>교육시간표</span>
                                    {Object.keys(grouped).length ? (
                                        <>
                                        {Object.entries(grouped).map(([date, list]) =>
                                            renderSchedule(date, list),
                                        )}
                                        </>
                                    ) : null}

                                     {/* <span>폐강기준</span>
                                    교육생 인원이 10명 미만일 경우 자동으로 페강 처리 되며 교육일자 변경 또는 환불 됩니다  */}
                                    {/* <div className="box-border" style={{marginTop:"10px", marginBottom:"20px"}}>
                                        <span className="txt-red">유의사항</span> */}
                                        {/* <b className="txt-point-img"><img src="/img/btn_point.png" alt="포인트" />환불조건</b> 신청후 <b className="txt-blue">3일 유예기간</b> 까지 교육비 <b className="txt-blue">미결제 상태인 경우 신청</b> 취소 처리되며 <b className="txt-blue">신청 마감일 이후로부터~교육 당일 출석확인 전까지는 교육비
                                        환불 불가</b> */}
                                    {/* </div> */}

                                    <div className="text-cent" style={{marginTop:"15px"}}>
                                        {/* 0. 비로그인: 목록만 */}
                                        {!auth.isAuthenticated && (
                                            <button className="btn btn-blue" onClick={handleList}>목록으로</button>
                                        )}
                                        {/* 0-1. 관리자에서 추가 (단체신청) */}
                                        {auth.isAuthenticated && isManaged && (
                                            <button className="btn btn-blue" onClick={handleList}>목록으로</button>
                                        )}

                                        {/* 1. 신청 기록이 없음 */}
                                        {auth.isAuthenticated && applyStatus === null && (
                                            <>
                                            <button className="btn btn_red" onClick={openModal}>교육 신청</button>
                                            <button className="btn btn-blue ml10" onClick={handleList}>목록으로</button>
                                            </>
                                        )}

                                        {/* 2. 승인 대기(A) */}
                                        {auth.isAuthenticated && isPending && (
                                            <>
                                            <button className="btn btn_red" onClick={handleCancelApply}>교육 신청 취소</button>
                                            <button className="btn btn_blue ml10" onClick={() => setIsDoneModal(true)}>교육 신청 확인</button>
                                            <button className="btn btn-blue ml10" onClick={handleList}>목록으로</button>
                                            </>
                                        )}

                                        {/* 3. 승인 완료(B) – 취소 불가 */}
                                        {auth.isAuthenticated && isApproved && (
                                            <>
                                            <button className="btn btn_blue" onClick={() => setIsDoneModal(true)}>교육 신청 확인</button>
                                            <button className="btn btn-blue ml10" onClick={handleList}>목록으로</button>
                                            </>
                                        )}

                                        {/* 4. 승인취소(C)·신청취소(N)·반려(R) */}
                                        {auth.isAuthenticated && isReapply && (
                                            <>
                                            <button className="btn btn_red" onClick={openModal}>재신청</button>
                                            <button className="btn btn_blue ml10" onClick={() => setIsDoneModal(true)}>이전 신청 확인</button>
                                            <button className="btn btn-blue ml10" onClick={handleList}>목록으로</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>  
                        </div>  
                    </div>
                    <Footer />
                </div>
            </div>
        </main>
        <NoticeAgreeModal
        isOpen={isNoticeOpen}
        onClose={() => setIsNoticeOpen(false)}
        onConfirm={openUserModalAfterNotice}
      />
        <ModalUser
            isOpen={isModalOpen}
            lecture={lecture}
            onClose={() => setIsModalOpen(false)}
            onOpenConfirm={handleApplyDone}
        />
        <ApplyCompleteModal
            isOpen={isDoneModal}
            onClose={() => setIsDoneModal(false)}
            lecture={lecture}
        />
       </>
    );

};

export default LectureDetail;
